import { Pill, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useState } from 'react';

import { Select } from '@components';
import { searchBatchName } from '@hooks/batch';
import { IDropDownOption } from '@interfaces';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseBatchesProps {
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  disabled: boolean;
}

export const HouseBatches: React.FC<HouseBatchesProps> = ({ houseForm, disabled }) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState<IDropDownOption | null>(null);
  const [searchValue, setSearchValue] = useState('');

  const search = async (searchText: string) => {
    setSearchValue(searchText || '');

    if (!searchText) {
      return [];
    }

    const results = await searchBatchName(searchText);

    setData(
      results.map((result) => ({
        label: result.name,
        value: result.id,
      })),
    );
  };

  const { batches } = houseForm.values;

  const setBatches = (newBatches) => {
    houseForm.setFieldValue('batches', newBatches);
  };

  const addBatch = (selectedOptionValue) => {
    const selectedOption = data.find((item) => item.value === selectedOptionValue);

    if (!batches.find((item) => item.id === selectedOptionValue)) {
      setBatches([...batches, { id: selectedOption.value, name: selectedOption.label }]);
    }

    setValue(null);
    setSearchValue('');
    setData([]);
  };

  return (
    <Stack mt="md" gap="xl">
      <Select
        data-pw="house-consigment-batches-select"
        searchable
        label="Search and add batch"
        data={data}
        value={value ? value.value : null}
        searchValue={searchValue}
        onSearchChange={search}
        onOptionSubmit={addBatch}
        size="xl"
        disabled={disabled}
      ></Select>

      <Pill.Group>
        {batches.map((item, itemIdx) => (
          <Pill key={(batches?.length || 0) + itemIdx} size="xl" data-pw={`house-consigment-batch-pill-${itemIdx}`}>
            {item.name}
          </Pill>
        ))}
      </Pill.Group>
    </Stack>
  );
};
